import { createBrowserRouter } from 'react-router-dom';

import { ProtectedRoute } from '../components/ProtectedRoute';
import { AcceptAdminInvitePage } from '../pages/AcceptAdminInvitePage';
import { ActivityPage } from '../pages/ActivityPage';
import { BankAccountsPage } from '../pages/BankAccountsPage';
import { ClientDetailPage } from '../pages/ClientDetailPage';
import { ClientListPage } from '../pages/ClientListPage';
import { ChatsPage } from '../pages/ChatsPage';
import { DashboardPage } from '../pages/DashboardPage';
import { DeleteAccountPage } from '../pages/DeleteAccountPage';
import { ForbiddenPage } from '../pages/ForbiddenPage';
import { ForgotPasswordPage } from '../pages/ForgotPasswordPage';
import { HelpArticlesPage } from '../pages/HelpArticlesPage';
import { LoginPage } from '../pages/LoginPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { NotificationsPage } from '../pages/NotificationsPage';
import { PointsRewardsPage } from '../pages/PointsRewardsPage';
import { ProfilePage } from '../pages/ProfilePage';
import { ResetAdminPasswordPage } from '../pages/ResetAdminPasswordPage';
import { RolesPage } from '../pages/RolesPage';
import { TasksPage } from '../pages/TasksPage';
import { TeamPage } from '../pages/TeamPage';
import { TestimonialsPage } from '../pages/TestimonialsPage';

export const router = createBrowserRouter([
  {
    path: '/delete-account',
    element: <DeleteAccountPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/admin/accept-invite',
    element: <AcceptAdminInvitePage />,
  },
  {
    path: '/admin/reset-password',
    element: <ResetAdminPasswordPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: '/',
        element: <DashboardPage />,
      },
      {
        path: '/clients',
        element: <ClientListPage />,
      },
      {
        path: '/chats',
        element: <ChatsPage />,
      },
      {
        path: '/activity',
        element: <ActivityPage />,
      },
      {
        path: '/bank-accounts',
        element: <BankAccountsPage />,
      },
      {
        path: '/clients/:id',
        element: <ClientDetailPage />,
      },
      {
        path: '/help-articles',
        element: <HelpArticlesPage />,
      },
      {
        path: '/profile',
        element: <ProfilePage />,
      },
      {
        path: '/notifications',
        element: <NotificationsPage />,
      },
      {
        path: '/testimonials',
        element: <TestimonialsPage />,
      },
      {
        path: '/forbidden',
        element: <ForbiddenPage />,
      },
    ],
  },
  {
    element: <ProtectedRoute permission="roles:manage" />,
    children: [
      {
        path: '/roles',
        element: <RolesPage />,
      },
    ],
  },
  {
    element: <ProtectedRoute permission="users:manage" />,
    children: [
      {
        path: '/team',
        element: <TeamPage />,
      },
    ],
  },
  {
    element: <ProtectedRoute permission="tasks:view" />,
    children: [
      {
        path: '/tasks',
        element: <TasksPage />,
      },
    ],
  },
  {
    element: <ProtectedRoute permission="points:manage" />,
    children: [
      {
        path: '/points-rewards',
        element: <PointsRewardsPage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
